<template>
  <div>
    <div class="b-ipv-container">
      <div class="b-ipv-container-ipv-column" v-if="details.video_verification_status =='on_hold'">
        <h3>User Details</h3>
        <div class="b-ipv-container__form">
          <div>
            <div class="b-ipv-container__form_row">
              <input
                type="checkbox"
                id="gender"
                value="gender"
                :checked="checkDetails['gender']"
                @change="$emit('checkDetail', 'gender')"
              />
              <label for="gender">Gender : {{details.gender}}</label>
              <br />
            </div>
            <div class="b-ipv-container__form_row">
              <input
                type="checkbox"
                id="video"
                value="video"
                :checked="checkDetails['video']"
                @change="$emit('checkDetail', 'video')"
              />
              <label for="video">Person is same as per picture/video</label>
              <br />
            </div>
          </div>
        </div>
        <div class="b-ipv-container__btn">
          <button @click="$emit('goNext')" class="b-global__button">NEXT</button>
        </div>
      </div>

      <div class="b-ipv-container-ipv-column">
        <h3 v-if="details.video_verification_status =='on_hold'">User Proof</h3>
        <div class="b-ipv-container__row">
          <div class="b-ipv-container-ipv-video">
      
            <video controls style="width:100%" controlslist>
               <source :src="details.url_video_verification" type="video/webm">
                <source :src="details.url_video_verification"  type="video/ogg">
              <source :src="details.url_video_verification" type="video/mp4" >
              
            </video>
            <div class="b-ipv-container__img-label" v-if="details.verification_code">Verification code shown by Kuvera:  {{details.verification_code}}</div>
            <div class="b-ipv-container__img-label">IPV video</div>
          <div class="b-ipv-container__download-btn"> <a :href="details.url_video_verification">Download Video</a></div>  
          <div class="b-ipv-container__btn" v-if="details.video_verification_status !='on_hold'">
            <button @click="$emit('goNext')" class="b-global__button">NEXT</button>
          </div>
          </div>
        </div>

        <div class="b-ipv-container__row" v-if="details.video_verification_status =='on_hold'">
          <img v-bind:src="details.url_photo" alt="User Profile" style="width:100%" />

          <div class="b-ipv-container__img-label">Profile Image</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    checkDetails: {
      type: Object
    },

    details: {
      type: Object,
      required: true
    }
  },

  methods: {
    checkedNames: function(element) {
      let array = ["IPV", element];
      this.$emit("checkedBox", array);
    },
  //   handleDownloadVideo(){
  //      let link = document.createElement("a");
  //       link.download = `${this.details.url_video_verification}_ipvVideo`;
  // link.href = this.details.url_video_verification;
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  // // delete link;
  //     // window.location.href = this.details.url_video_verification;
  //   }
  }
};
</script>

<style scoped>
.b-ipv-container {
  margin-top: 40px;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
}
.b-ipv-container h3 {
  display: flex;
  justify-content: center;
}
.b-ipv-container__img {
  width: 250px;
  height: 250px;
  background-color: bisque;
}
.b-ipv-container__img {
  width: 250px;
  height: 250px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: bisque;
}
.b-ipv-container__form {
  width: 328px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  margin: 15px;
}
.b-ipv-container__error {
  color: #d8000c;
}
.b-ipv-container button {
  margin-top: 15px;
}
.b-ipv-container__img-label {
  text-align: center;
  margin: 10px;
}
.b-ipv-container-ipv-row {
  display: flex;
  justify-content: space-evenly;
}
.b-ipv-container-ipv-column {
  display: flex;
  flex-direction: column;
  margin: 30px;
}
.b-ipv-container-ipv-video {
  margin-bottom: 20px;
}

.b-ipv-container__form_row {
  border-bottom: solid 1px #e0e0e0;
  padding: 10px;
}
.b-ipv-container__btn {
  display: flex;
  justify-content: center;
}
.b-ipv-container__row {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}
.b-ipv-container__download-btn{
  display: flex;
  justify-content: center
}
</style>